import React, { useEffect, useState } from "react";
import { Typography, Box, IconButton, Button, Divider } from "@mui/material";
import { useTheme } from "@mui/material/styles";
import Grid from "@mui/material/Grid2";
import { Facebook, Instagram } from "@mui/icons-material";
import InstallPWA from "./InstallPWA";
import { useCompany } from "../context/CompanyContext";
const Footer: React.FC = () => {
  const theme = useTheme();
  const [isFirstImage, setIsFirstImage] = useState(true);
  const { company } = useCompany();


  useEffect(() => {
    const interval = setInterval(() => {
      setIsFirstImage((prev) => !prev);
    }, 3000);

    return () => clearInterval(interval);
  }, []);

  return (
    <Box
      sx={{
        backgroundColor: theme.palette.grey[100],
        py: 6,
        px: { xs: 2, sm: 4, md: 10 },
      }}
    >
      <Box>
        <Grid
          container
          spacing={8}
          justifyContent="space-around"
          sx={{ py: 4 }}
        >
          <Grid
            size={{ xs: 12, md: 2 }}
            sx={{
              display: "flex",
              flexDirection: "column",
              gap: 2,
              alignItems: { xs: "center", md: "flex-start" },
              justifyContent: "center",
            }}
          >
            <Button
              variant="outlined"
              startIcon={
                <Box
                  component="img"
                  src="/assets/images/ios.png"
                  alt="iOS icon"
                  sx={{ width: 32, height: 32 }}
                />
              }
              href="https://apps.apple.com/cr/app/alien-realty-app/id6738670454"
              target="_blank"
              sx={{
                borderRadius: "12px",
                borderWidth: 2,
                px: { xs: 3, md: 2 },
                py: { xs: 1.5, md: 0.5 },
                color: "#1e1e1e",
                borderColor: "#1e1e1e",
                fontWeight: "600",
                fontSize: "1rem",
                textTransform: "none",
                transition: "all 0.3s ease",
                lineHeight: 1.5,
                "&:hover": {
                  backgroundColor: "#1e1e1e",
                  color: "#fff",
                  borderColor: "#1e1e1e",
                },
              }}
            >
              Descargar para iOS
            </Button>
            <Button
              variant="outlined"
              startIcon={
                <Box
                  component="img"
                  src="/assets/images/android.png"
                  alt="Android icon"
                  sx={{ width: 32, height: 32 }}
                />
              }
              href="https://play.google.com/store/apps/details?id=com.orbitas.alien_realty_app"
              target="_blank"
              sx={{
                borderRadius: "12px",
                borderWidth: 2,
                px: { xs: 3, md: 2 },
                py: { xs: 1.5, md: 0.5 },
                color: "#388e3c",
                borderColor: "#388e3c",
                fontWeight: "600",
                fontSize: "1rem",
                textTransform: "none",
                transition: "all 0.3s ease",
                lineHeight: 1.5,
                "&:hover": {
                  backgroundColor: "#388e3c",
                  color: "#fff",
                  borderColor: "#388e3c",
                },
              }}
            >
              Descargar para Android
            </Button>
            <InstallPWA />
          </Grid>

          {/* Middle content - Sections */}
          <Grid container size={{ xs: 12, md: 8 }} spacing={8}>
            <Grid
              size={{ xs: 12, md: 3 }}
              sx={{ textAlign: { xs: "center", md: "left" } }}
            >
              <Typography
                variant="h6"
                gutterBottom
                sx={{ fontWeight: "bold", color: "gray.800" }}
              >
                ACERCA DE
              </Typography>
              <Box sx={{ display: "flex", flexDirection: "column", gap: 1.2 }}>
                {[
                  "¿Qué es Alien Realty?",
                  "Cómo funciona",
                  "Página informativa",
                  "Nuestros módulos",
                ].map((text, i) => (
                  <Typography
                    key={i}
                    variant="body2"
                    sx={{ cursor: "pointer", color: "black" }}
                  >
                    {text}
                  </Typography>
                ))}
                {/* Agregar el enlace de Noticias dentro de la misma sección */}
                <Typography
                  variant="body2"
                  sx={{
                    cursor: "pointer",
                    color: "black",
                    "&:hover": { textDecoration: "underline" },
                  }}
                  onClick={() =>
                    (window.location.href =
                      "https://www.elfinancierocr.com/emprender/un-emprendedor-incorpora-ia-en-sus-soluciones/R3PFCZCSJFGSBN2WE7FHYWJWS4/story/")
                  }
                >
                  Ver nuestras noticias
                </Typography>
              </Box>
            </Grid>

            <Grid
              size={{ xs: 12, md: 3 }}
              sx={{ textAlign: { xs: "center", md: "left" } }}
            >
              <Typography
                variant="h6"
                gutterBottom
                sx={{ fontWeight: "bold", color: "gray.800" }}
              >
                ALIEN REALTY
              </Typography>
              <Box sx={{ display: "flex", flexDirection: "column", gap: 1.2 }}>
                <Typography variant="body2">Prueba nuestra app</Typography>
                <Typography variant="body2">Todo en un solo lugar</Typography>
                <Typography variant="body2">Gestiona desde tu móvil</Typography>
                <Typography
                  variant="body2"
                  onClick={() =>
                    (window.location.href =
                      "https://play.google.com/store/apps/details?id=com.orbitas.alien_realty_app")
                  }
                  sx={{
                    cursor: "pointer",
                    color: "black",
                    "&:hover": { textDecoration: "underline" },
                  }}
                >
                  Descarga para Android
                </Typography>
                <Typography
                  variant="body2"
                  onClick={() =>
                    (window.location.href = "https://apps.apple.com/cr/app/alien-realty-app/id6738670454") //no se actualiza en el host?
                  }
                  sx={{
                    cursor: "pointer",
                    color: "black",
                    "&:hover": { textDecoration: "underline" },
                  }}
                >
                  Descarga para IOS
                </Typography>
              </Box>
            </Grid>

            <Grid
              size={{ xs: 12, md: 3 }}
              sx={{ textAlign: { xs: "center", md: "left" } }}
            >
              <Typography
                variant="h6"
                gutterBottom
                sx={{ fontWeight: "bold", color: "gray.800" }}
              >
                BROKERS
              </Typography>
              <Box sx={{ display: "flex", flexDirection: "column", gap: 1.2 }}>
                <Typography variant="body2">Soluciones integrales</Typography>
                <Typography variant="body2">Red de brokers</Typography>
                <Typography variant="body2">Expertos en el sector</Typography>
                <Typography variant="body2">10+ años de experiencia</Typography>
                <Typography variant="body2">Únete Ahora</Typography>
              </Box>
            </Grid>

            <Grid
              size={{ xs: 12, md: 3 }}
              sx={{ textAlign: { xs: "center", md: "left" } }}
            >
              <Typography
                variant="h6"
                gutterBottom
                sx={{ fontWeight: "bold", color: "gray.800" }}
              >
                SOPORTE
              </Typography>
              <Box sx={{ display: "flex", flexDirection: "column", gap: 1.2 }}>
                <Typography variant="body2">Centro de Ayuda</Typography>
                <Typography variant="body2">Confianza y Seguridad</Typography>
                <Typography variant="body2">Envíanos comentarios</Typography>
                <Typography variant="body2">
                  Asistencia personalizada
                </Typography>
                <Typography variant="body2" onClick={() => window.location.reload()} sx={{ cursor: "pointer", color: "black", "&:hover": { textDecoration: "underline" } }}>Limpiar Caché</Typography>
              </Box>
            </Grid>
          </Grid>

          <Grid
            size={{ xs: 12, md: 2 }}
            sx={{
              display: "flex",
              justifyContent: { xs: "center", md: "flex-end" },
              position: "relative",
              height: 150,
              width: 150,
            }}
          >
            {company ? (
              // Si hay company, mostrar su logo
              <Box
                component="img"
                src={company.customSettings.logoUrl || "/assets/images/company-logo.png"}
                alt={company.name || "Company Logo"}
                sx={{
                  position: "absolute",
                  top: 0,
                  left: 0,
                  height: "100%",
                  width: "100%",
                  objectFit: "contain",
                }}
              />
            ) : (
              // Si no hay company, mostrar animación Alien Realty
              <>
                <Box
                  component="img"
                  src="/assets/images/logo-alien3-v3.png"
                  alt="Alien Realty Logo"
                  sx={{
                    position: "absolute",
                    top: 0,
                    left: 0,
                    height: "100%",
                    width: "100%",
                    objectFit: "contain",
                    transition: "opacity 0.5s ease-in-out",
                    opacity: isFirstImage ? 1 : 0,
                  }}
                />

                <Box
                  component="img"
                  src="/assets/images/logo-alien4-v3.png"
                  alt="Alien Realty Logo 2"
                  sx={{
                    position: "absolute",
                    top: 0,
                    left: 0,
                    height: "100%",
                    width: "100%",
                    objectFit: "contain",
                    transition: "opacity 0.5s ease-in-out",
                    opacity: isFirstImage ? 0 : 1,
                  }}
                />
              </>
            )}
          </Grid>

        </Grid>

        {/* Divider before bottom social section */}
        <Box sx={{ mt: 4 }}>
          <Divider />
        </Box>

        {/* Social media icons - Bottom section */}
        <Box sx={{ mt: 4, display: "flex", justifyContent: "center", gap: 3 }}>
          <IconButton
            aria-label="Facebook"
            href="https://www.facebook.com/people/Al%C3%ADen-Realty/61555710022289/"
            target="_blank"
            sx={{ color: theme.palette.primary.main }}
          >
            <Facebook />
          </IconButton>
          <IconButton
            aria-label="Instagram"
            href="https://www.instagram.com/alienrealty/"
            target="_blank"
            sx={{ color: theme.palette.primary.main }}
          >
            <Instagram />
          </IconButton>
        </Box>

        {/* Copyright */}
        <Typography
          variant="body2"
          color="text.secondary"
          align="center"
          sx={{ mt: 3 }}
        >
          © {new Date().getFullYear()} Alien Realty. Todos los derechos
          reservados.
        </Typography>
      </Box>
      <Box
        sx={{
          height: "80px",
          display: { xs: "block", sm: "none" },
          width: "100%",
        }}
      />
    </Box>
  );
};

export default Footer;
